var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95111 0.00292969C13.9041 0.00292969 17.9022 4.00109 17.9022 8.95404C17.9022 10.9322 17.2645 12.758 16.1829 14.2376L24 22.0541L22.0567 23.9973L14.2413 16.181C12.7605 17.2655 10.9322 17.9052 8.95111 17.9052C3.99816 17.9052 0 13.907 0 8.95404C0 4.00109 3.99816 0.00292969 8.95111 0.00292969ZM8.95111 2.77058C5.5296 2.77058 2.76765 5.53253 2.76765 8.95404C2.76765 12.3756 5.5296 15.1375 8.95111 15.1375C12.3726 15.1375 15.1346 12.3756 15.1346 8.95404C15.1346 5.53253 12.3726 2.77058 8.95111 2.77058Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/search icon.7552871c8d87f387bb481ad5ad3a4682.svg";
export { ForwardRef as ReactComponent };